module.exports = __webpack_public_path__ + "assets/1-San-Francisco-Tech-Recruiters.6c4bc23e.png";